import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../shared/services/notification.service';
import { Router } from '@angular/router';
import { PayUtilityBillsForm } from './pay-utility-bills-form/pay-utility-bills-form';
import { MobileRechargeForm } from './mobile-recharge-form/mobile-recharge-form';
import { CreditCardBillForm } from './credit-card-bill-form/credit-card-bill-form';

interface Category {
  id: string;
  name: string;
  icon: string;
}
interface CreditCard {
  id: string;
  bank: string;
  brand: 'Mastercard' | 'Visa';
  lastFour: string;
  amount: string;
  dueDate: string;
  logo: string;
}

@Component({
  selector: 'app-bills',
  standalone: true,
  imports: [CommonModule, PayUtilityBillsForm, MobileRechargeForm, CreditCardBillForm],
  templateUrl: './bills.html',
  styleUrl: './bills.scss',
})
export class Bills {
  currentStep: 'selection' | 'categories' | 'form' | 'mobile-categories' | 'mobile-form' | 'credit-categories' | 'credit-form' = 'selection';
  selectedCategory: Category | null = null;

  categories: Category[] = [
    { id: 'electricity', name: 'Electricity', icon: 'assets/icons/utility-electricity.svg' },
    { id: 'water', name: 'Water', icon: 'assets/icons/utility-water.svg' },
    { id: 'gas', name: 'Gas', icon: 'assets/icons/utility-gas.svg' },
    { id: 'broadband', name: 'Broadband', icon: 'assets/icons/utility-broadband.svg' },
    { id: 'mobile', name: 'Mobile Postpaid', icon: 'assets/icons/utility-mobile.svg' },
    { id: 'government', name: 'Government', icon: 'assets/icons/utility-government.svg' },
  ];

  mobileCategories: Category[] = [
    { id: 'aircel', name: 'Aircel', icon: 'assets/icons/mobileCat.png' },
    { id: 'airtel', name: 'Airtel', icon: 'assets/icons/image 7.png' },
    { id: 'jio', name: 'Jio', icon: 'assets/icons/mobileCat.png' },
    { id: 'vi', name: 'Vi', icon: 'assets/icons/image 7.png' },
  ];

  creditCards: CreditCard[] = [
    {
      id: 'hdfc-mastercard',
      bank: 'HDFC Bank - Mastercard',
      brand: 'Mastercard',
      lastFour: '1234',
      amount: '₹ 12,450',
      dueDate: 'Due on 25 Sep',
      logo: 'assets/icons/mastercard.svg'
    },
    {
      id: 'hdfc-visa',
      bank: 'HDFC Bank - Visa',
      brand: 'Visa',
      lastFour: '5071',
      amount: '₹ 12,450',
      dueDate: 'Due on 25 Sep',
      logo: 'assets/icons/Visa_2021.svg'
    }
  ];
  selectedCreditCard: CreditCard | null = null;

  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) { }

  goToUtilityCategories() {
    this.currentStep = 'categories';
  }

  selectCategory(cat: Category) {
    this.selectedCategory = cat;
    if (this.currentStep === 'categories') this.currentStep = 'form';
    else if (this.currentStep === 'mobile-categories') this.currentStep = 'mobile-form';
    else if (this.currentStep === 'credit-categories') this.currentStep = 'credit-form';
  }

  goBack(step?: any) {
    if (this.currentStep === 'form') {
      this.currentStep = 'categories';
    } else if (this.currentStep === 'mobile-form') {
      this.currentStep = 'mobile-categories';
    } else if (this.currentStep === 'credit-form') {
      this.currentStep = 'credit-categories';
    } else if (this.currentStep === 'categories' || this.currentStep === 'mobile-categories' || this.currentStep === 'credit-categories') {
      this.currentStep = 'selection';
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  goToMobileCategories() {
    this.currentStep = 'mobile-categories';
  }

  goToCreditCardCategories() {
    this.currentStep = 'credit-categories';
  }

  openCreditCardForm(card: CreditCard) {
    this.selectedCreditCard = card;
    this.currentStep = 'credit-form';
  }

  toggleNotifications() {
    this.notificationService.toggle();
  }
}